module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.22147/js/img/splash-page/suite-card-top-right-blob.svg"